const routes = [
    {
        path: '/assinatura_digital',
        redirect: '/assinatura_digital/inicio'
    },
    {
        path: '/assinatura_digital/inicio',
        component: () => import('../views/Inicio')
    },
    {
        path: '/assinatura_digital/sistema/inicio',
        redirect: '/assinatura_digital/inicio'
    }
]
export default routes
  